export default {"src":"/_next/static/media/capture.694e1686.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};